import styled from "styled-components"

export default styled.img`
  width: 100%;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  box-shadow: 0 0 0 1px ${({theme}) => theme.colors.greys.light};
  ${(props) => (props.compactMode ? "height: 104px" : null)}
`
